import React from "react";
import { motion } from "framer-motion";

export function HowItWorks({ t }) {
  return (
    <section id="how" className="relative section-pad border-t border-white/10 bg-[#0E162F]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#00E5FF]" />
              <span className="eyebrow">{t.how.eyebrow}</span>
            </div>
            <h2
              className="text-white font-semibold leading-[1.05] tracking-tight"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(30px, 4.5vw, 48px)",
              }}
            >
              {t.how.heading}
            </h2>
          </div>

          <div className="md:col-span-7">
            <ol className="relative">
              {/* vertical line */}
              <span className="absolute left-[22px] top-3 bottom-3 w-px bg-white/10" aria-hidden="true" />
              {t.how.steps.map((s, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
                  className="relative pl-16 pb-10 last:pb-0"
                  data-testid={`how-step-${i}`}
                >
                  <span
                    className="absolute left-0 top-0 w-11 h-11 rounded-full bg-[#0B132B] border border-[#00E5FF]/40 flex items-center justify-center text-[#00E5FF] font-bold"
                    style={{ fontFamily: "'Outfit', sans-serif", fontSize: "16px" }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3
                    className="text-white font-semibold"
                    style={{ fontFamily: "'Outfit', sans-serif", fontSize: "22px" }}
                  >
                    {s.title}
                  </h3>
                  <p
                    className="mt-2 text-[#9BA1A6] leading-relaxed max-w-xl"
                    style={{ fontFamily: "'Manrope', sans-serif", fontSize: "16px" }}
                  >
                    {s.body}
                  </p>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
